module.exports = __webpack_public_path__ + "static/media/suspenso.caf2abc2.svg";